<span class="name" [class.opened]="opened" (click)="opened = !opened" (keydown.enter)="opened = !opened" (keydown.space)="opened = !opened" tabindex="0">
  {{ 'DASHBOARD.LAYERS' | translate }}
  <mat-icon class="open-icon" svgIcon="go_back"></mat-icon>
</span>

<div class="items" [class.opened]="opened">
  @for (item of sortedItems; track item.id) {
    <div
      class="item"
      (click)="select(item)"
      (keydown.enter)="select(item)"
      (keydown.space)="select(item)"
      (mouseenter)="layerSelected(item.id)"
      (mouseleave)="layerUnselected(item.id)"
      tabindex="0"
    >
      <p class="item-name">
        <mat-icon svgIcon="{{ getItemTypeIcon(item.type) }}"></mat-icon>
        <span>{{ getItemName(item) }}</span>
      </p>
    </div>
  }
</div>
